<template>
  <span @mousedown.prevent="(e) => e.stopPropagation()" @click="onClick" class="keyboard-key" :class="[keyClass, stated ? 'stated' : '', uppercase ? 'uppercase' : '']" :style="`flex-grow: ${importance}`">
    {{ displayKey }}
  </span>
</template>

<script>
export default {
  props:{
    key_label: [String, Number, Array],
    control_states: Object
  },
  methods: {
    onClick(){
      if (this.keymatch[4] === undefined) {
        this.$emit('click', this.displayKey)
      } else {
        this.$emit('layout', this.keymatch[4])
      }
    }
  },
  computed: {
    uppercase(){
      if (this.control_states.caps) {
        return this.control_states.shift ? false : true
      } else {
        return this.control_states.shift ? true : false
      }
    },
    stated(){
      if (this.displayKey == 'shift') {
        return this.control_states.shift || false
      } else if (this.displayKey == 'ctrl') {
        return this.control_states.ctrl || false
      } else if (this.displayKey == 'alt') {
        return this.control_states.alt || false
      } else if (this.displayKey == 'caps') {
        return this.control_states.caps || false
      } else {
        return false
      }
    },
    displayKey(){
      return this.keymatch[5] || this.keymatch[2] || this.keymatch[3]
      // return this.normalizedKey.replaceAll('{', '').replaceAll('}', '').replaceAll('!', '')
    },
    importance(){
      // return (this.normalizedKey.match(/!/g) || []).length + 1
      return this.keymatch[1].length + 1
    },
    normalizedKey(){
      if (typeof(this.key_label) == 'object') {
        if (this.control_states.shift) { 
          return ''+(this.key_label[1] || this.key_label[0])
        }   else {
          return ''+this.key_label[0]
        }
      } else {
        return ''+this.key_label
      }
    },
    keymatch(){
      return this.normalizedKey.match(/(!*)(?:(?:\((\S*)\))|(?:\{(\S*)\})|(?:<(\S*):(\S*)>))/) || [this.normalizedKey, '', this.normalizedKey, undefined, undefined, undefined]
    },
    keyClass(){
      return this.keymatch[3] || this.keymatch[4] ? 'key-functional' : 'key-letter'
      // if (this.normalizedKey.match(/{\S+}/)) {
      //   return 'key-functional'
      // } else {
      //   return 'key-letter'
      // }
    }
  }
}
</script>

<style>
.keyboard-key {
  cursor: pointer;
  /* background-color: gray; */
  border-radius: 4px;
  /* color: white; */
  margin: 4px;
  /* width: 100%; */
  /* flex-grow: 1; */
  padding: .9em .1em;
  /* padding-left: 1em;
  padding-right: 1em;
  padding-top: .9em;
  padding-bottom: .9em; */
  text-align: center;
  justify-self: stretch;
  align-self: stretch;

  -webkit-box-shadow: 0px 13px 14px -4px rgba(34, 60, 80, 0.27);
  -moz-box-shadow: 0px 13px 14px -4px rgba(34, 60, 80, 0.27);
  box-shadow: 0px 13px 14px -4px rgba(34, 60, 80, 0.27);

  transition: all .04s ease-in-out;

  font-family: 'Consolas', Courier, monospace;

  user-select: none;
}

.keyboard-key:active {
  -webkit-box-shadow: 0px 7px 11px -4px rgba(34, 60, 80, 0.27);
  -moz-box-shadow: 0px 7px 11px -4px rgba(34, 60, 80, 0.27);
  box-shadow: 0px 7px 11px -4px rgba(34, 60, 80, 0.27), 0px 0px 18px -4px rgba(34, 60, 80, 0.27) inset;
  transform: scale(0.95);
}

.key-letter {
  max-width: 4em;
  color: var(--v-secondary-darken4);
  background-color: var(--v-secondary-lighten3);
}

.key-functional {
  background-color: var(--v-primary-base);
  color: white;
  /* text-decoration: underline; */
  text-transform: uppercase;
  /* background-color: cadetblue; */
}

.stated {
  transform: scale(.95);
  background-color: var(--v-primary-darken2);
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

</style>